import { fullstoryEvent } from '@/fullstory/utils/fullstory-event';
import { getSortNameReadableFormat } from '../utils/sort-naming-util';
import {
  PlainSelectTrigger,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
} from '@/shadcn-ui/select';
import { useFetcher } from 'react-router';
import SortTrigger from './sort-trigger';
import useIsClient from '@/util-react-router/hooks/use-is-client';

interface SortSelectProps {
  disabled?: boolean;
  sortValue: string;
  setSortValue: (value: string) => void;
  sortTriggerConfiguration?: {
    classNameText?: string;
    chevronFill?: string;
  };
}

export default function SortSelect({
  disabled,
  sortValue,
  setSortValue,
  sortTriggerConfiguration,
}: SortSelectProps) {
  const fetcher = useFetcher();

  const isClient = useIsClient();

  const onValueChange = (value: string) => {
    setSortValue(value);
    fullstoryEvent('sort_by_changed', { sorting_method: value });
  };

  if (!isClient) {
    // Render a placeholder during SSR
    <SortTrigger disabled />;
  }

  return (
    <fetcher.Form>
      <div className="outline-none focus:outline-none">
        <Select
          defaultValue={sortValue}
          onValueChange={onValueChange}
          disabled={disabled}
        >
          <PlainSelectTrigger disabled={disabled}>
            <SortTrigger
              option={sortValue}
              disabled={disabled}
              classNameText={sortTriggerConfiguration?.classNameText}
              chevronFill={sortTriggerConfiguration?.chevronFill}
            />
          </PlainSelectTrigger>

          <SelectContent>
            <SelectGroup>
              <SelectLabel>Sort by</SelectLabel>
              <SelectSeparator />
              <SelectItem value="popular" className="cursor-pointer">
                {getSortNameReadableFormat('popular')}
              </SelectItem>
              <SelectItem value="low_to_high" className="cursor-pointer">
                {getSortNameReadableFormat('low_to_high')}
              </SelectItem>
              <SelectItem value="high_to_low" className="cursor-pointer">
                {getSortNameReadableFormat('high_to_low')}
              </SelectItem>
              <SelectItem value="recently_added" className="cursor-pointer">
                {getSortNameReadableFormat('recently_added')}
              </SelectItem>
              <SelectItem value="earliest_available" className="cursor-pointer">
                {getSortNameReadableFormat('earliest_available')}
              </SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </fetcher.Form>
  );
}
